export const subApplicants = [
  {
    id: 2,
    name: "Devery Channell",
    first_name: "Devery",
    last_name: "Channell",
    community: {
      id: 2,
      name: "Alista",
    },
    status: "Completed",
    screening_type: "Guarantor",
    autoscore: "conditional",
    created: "Nov 15, 2023",
  },
    {
    id: 3,
    name: "Daniel Ramirez",
    first_name: "Daniel",
    last_name: "Ramirez",
    community: {
      id: 3,
      name: "Alista",
    },
    status: "Completed",
    screening_type: "Standard",
    autoscore: "",
    created: "Nov 15, 2023",
  },
  {
    id: 4,
    name: "Lukas M",
    first_name: "Lukas",
    last_name: "M",
    community: {
      id: 4,
      name: "Alista",
    },
    status: "Completed",
    screening_type: "Standard",
    autoscore: "pass",
    created: "Nov 15, 2023",
  },
];
